export default "__VITE_ASSET__DzmbU2vT__"